import React from 'react'
import { ReactComponent as CaretIcon } from 'images/Icon_Caret.svg'
import {
  MyInternalLink,
  MyLink,
  MyLinkClickHandler,
  MyLinkSiteActivityProps,
  MyLinkSiteActivityPropsV2
} from 'components/MyLink'

export interface IBreadCrumbProps {
  backButtonLink?: string
  linkIsExternal?: boolean
  backButtonText?: string
  className?: string
  width?: 'wide' | 'default'
  navAriaLabel: string
  siteActivityProps?: MyLinkSiteActivityProps | MyLinkSiteActivityPropsV2
  onClick?: MyLinkClickHandler
}

/**
 * BreadCrumb is a Navigation Component using React-Router
 * It serves as a Higher Order Component (HoC) applied to each route manually
 * Because some pages may or may not be breadcrumb navigation
 * Set the default backButton navigation to medicare.gov if nothing is specified
 *
 * If no backButtonLink is specified, apply the styles of a breadcrumb but not the navigation
 *
 * @param props
 * @returns
 */
export const BreadCrumb: React.FC<IBreadCrumbProps> = ({
  className,
  linkIsExternal,
  backButtonLink = '/',
  backButtonText = 'Home',
  width = 'default',
  navAriaLabel,
  siteActivityProps,
  onClick
}) => {
  return (
    <nav
      aria-label={navAriaLabel}
      className={`
      my-c-breadcrumb
      ds-u-visibility--hidden-print
      ${className ?? ''}
    `}
    >
      <div className="ds-l-container my-u-width--full">
        <div className="ds-l-row ds-u-justify-content--center">
          <div
            className={
              width === 'default'
                ? 'ds-l-col--12 ds-l-md-col--11 ds-l-lg-col--10'
                : 'ds-l-col--12'
            }
          >
            {linkIsExternal
              ? (
              <MyLink
                href={backButtonLink}
                className="my-c-breadcrumb-link"
                siteActivityProps={siteActivityProps}
                onClick={onClick}
              >
                <CaretIcon
                  className="my-c-caret--left my-u-mr--3"
                  aria-hidden
                  focusable={false}
                />
                <span>{backButtonText}</span>
              </MyLink>
                )
              : (
              <MyInternalLink
                to={backButtonLink}
                className="my-c-breadcrumb-link"
                siteActivityProps={siteActivityProps}
                onClick={onClick}
              >
                <CaretIcon
                  className="my-c-caret--left my-u-mr--3"
                  aria-hidden
                  focusable={false}
                />
                <span>{backButtonText}</span>
              </MyInternalLink>
                )}
          </div>
        </div>
      </div>
    </nav>
  )
}
